import api from './api';
import { Associate, AssociateFormData, ApiResponse, PaginatedResponse } from '../types';

export const associateService = {
  async getAll(page = 1, search = ''): Promise<PaginatedResponse<Associate>> {
    const response = await api.get<PaginatedResponse<Associate>>('/associates', {
      params: { page, search }
    });
    return response.data;
  },

  async getById(id: number): Promise<Associate> {
    const response = await api.get<Associate>(`/associates/${id}`);
    return response.data;
  },

  async getByCpf(cpf: string): Promise<Associate> {
    const response = await api.get<Associate>(`/associates/cpf/${cpf}`);
    return response.data;
  },

  async create(data: AssociateFormData): Promise<ApiResponse<Associate>> {
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        if (value instanceof File) {
          formData.append(key, value);
        } else if (typeof value === 'boolean') {
          // Enviar boolean como 1 ou 0 para o Laravel
          formData.append(key, value ? '1' : '0');
        } else {
          formData.append(key, String(value));
        }
      }
    });

    const response = await api.post<ApiResponse<Associate>>('/associates', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async update(id: number, data: AssociateFormData): Promise<ApiResponse<Associate>> {
    // Sempre usar FormData para manter consistência com o backend
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        if (value instanceof File) {
          formData.append(key, value);
        } else if (typeof value === 'boolean') {
          // Enviar boolean como 1 ou 0 para o Laravel
          formData.append(key, value ? '1' : '0');
        } else {
          formData.append(key, String(value));
        }
      }
    });

    // Importante: Laravel aceita POST com _method para simular PUT
    formData.append('_method', 'PUT');

    const response = await api.post<ApiResponse<Associate>>(`/associates/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async delete(id: number): Promise<ApiResponse<void>> {
    const response = await api.delete<ApiResponse<void>>(`/associates/${id}`);
    return response.data;
  },

  async updateStatus(id: number, status: 'ativo' | 'inativo' | 'suspenso'): Promise<ApiResponse<Associate>> {
    const response = await api.patch<ApiResponse<Associate>>(`/associates/${id}/status`, { status });
    return response.data;
  }
};
